import {ApiConfigPort} from '../config/api-config-port';
import {HttpService} from '../../services/http-service';
import {SingleResult, UpdateResult} from './lib-rest';

export class BannerApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async get(): Promise<SingleResult<BannerController$BannerJson> >  {
const url =  new URL('/banner', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async update(banner: BannerController$BannerJson): Promise<UpdateResult>  {
const url =  new URL('/banner', this.config.host);
    const queryParamsList: { name: string, value: string }[] = [];
if(banner.message !== undefined){queryParamsList.push({name: 'message', value: banner.message});}

    for (const queryParam of queryParamsList) {
url.searchParams.append(queryParam.name,queryParam.value);
    }

return (await HttpService.getAxiosClient().post(url.toString())).data
  }

}

export interface BannerController$BannerJson {
  message: string;
}

